import { colorsPalettes, colorsSets } from "@similarweb/styles";

import type { ChannelCanonical, ChannelDescriptions, ChannelKeyName } from "./MmxChannels";

const trafficSourcesColors = colorsSets.c.toArray();
const { blue, orange } = colorsPalettes;

// Competitors palette: colorsSets.c without the last two colors (sky 500 and others)
const competitorsColors = colorsSets.c.toArray().slice(0, -2);

export const CHART_COLORS = {
    benchmark: colorsSets.b3.toArray()[0],
    main: colorsSets.c.toArray(),
    DeduplicatedAudience: ["#4f8df9", "#8cd2ff", "#ff9a47"],
    mobileWeb: colorsSets.b1.toArray(),
    loadingColor: "#eeeeee",
    audienceOverview: colorsSets.c.toArray(),
    compareMainColors: colorsSets.c.toArray(),
    maleFemaleColors: colorsSets.b1.toArray(),
    trafficSourcesColors,
    newReturningUsersColors: {
        NewUsers: colorsSets.b1.toArray()[0],
        ReturningUsers: colorsSets.b1.toArray()[1],
    },
    /* eslint-disable @typescript-eslint/naming-convention -- MMX channel keys match BE/display names */
    trafficSourcesColorsBySourceMMX: {
        Direct: trafficSourcesColors[0],
        "Organic Search": trafficSourcesColors[1],
        OrganicSearch: trafficSourcesColors[1],
        Search: trafficSourcesColors[1],
        "Search - Organic": trafficSourcesColors[1],
        PaidSearch: trafficSourcesColors[2],
        "Paid Search": trafficSourcesColors[2],
        "Search - Paid": trafficSourcesColors[2],
        Referrals: trafficSourcesColors[3],
        "Display Ads": trafficSourcesColors[4],
        DisplayAds: trafficSourcesColors[4],
        PaidReferrals: trafficSourcesColors[4],
        "Paid Referrals": trafficSourcesColors[4],
        Social: trafficSourcesColors[5],
        "Social - Organic": trafficSourcesColors[5],
        "Organic Social": trafficSourcesColors[5],
        OrganicSocial: trafficSourcesColors[5],
        "Social - Paid": trafficSourcesColors[6],
        "Paid Social": trafficSourcesColors[6],
        PaidSocial: trafficSourcesColors[6],
        Email: trafficSourcesColors[7],
        Mail: trafficSourcesColors[7],
        GenAi: trafficSourcesColors[8],
        "Gen AI": trafficSourcesColors[8],
        "Internal Referrals": trafficSourcesColors[9],
        InternalReferrals: trafficSourcesColors[9],
        Affiliates: trafficSourcesColors[10],
    } satisfies Record<ChannelKeyName | ChannelDescriptions | ChannelCanonical, string>,
    /* eslint-enable @typescript-eslint/naming-convention */
    chartMainColors: colorsSets.c.toArray(),
    chartMainColorsWithoutOthers: colorsSets.c.toArray().filter((item) => item !== colorsSets.c.others),
    mobileDesktopColors: [...colorsSets.b1.toArray(), "inherit"],
    periodOverPeriod: {
        MobileWeb: [blue[400], orange[400]],
        MobileWebCombined: [blue[200], orange[200]],
        Desktop: [blue[400], orange[400]],
        Total: [blue[400], orange[400]],
        Common: { currentPeriod: blue[400], previousPeriod: orange[400] },
    },
    devicesColors: {
        Total: colorsSets.b3.toArray()[0],
        iPad: colorsSets.b1.toArray()[1],
        AndroidTablet: colorsSets.b1.toArray()[1],
        iPhone: colorsSets.b1.toArray()[0],
        AndroidPhone: colorsSets.b1.toArray()[0],
        Desktop: colorsSets.b1.toArray()[0],
        MobileWeb: colorsSets.b1.toArray()[1],
        "Mobile Web": colorsSets.b1.toArray()[1],
    },
    map: blue["500"],
    blue: [blue[400]],
    sourceType: {
        organic: colorsSets.b1.toArray()[0],
        paid: colorsSets.b1.toArray()[1],
    },
    fallbackColor: colorsPalettes.carbon[200],
    competitorsColors,
} as const;
